import { Icon } from "@material-ui/core";
import i18n from "i18next";
import { TemplateFilter } from "Models/Filters/TemplateFilter";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IApplicationState } from "Store/Store";
import { ITaskTemplateAction } from "Store/TaskTemplates/TaskTemplateAction";
import { ITaskTemplateState } from "Store/TaskTemplates/TaskTemplateState";
import styles from "./TaskTemplateSearch.scss";

const taskTemplateAction = ServiceProvider.get<ITaskTemplateAction>(Types.ITaskTemplateAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getTaskTemplatesByFilterAsync: (filter: TemplateFilter) =>
        dispatch(taskTemplateAction.getTaskTemplatesByFilterAsync(filter, true)),
});

const mapStateToProps = (state: IApplicationState) => ({
    taskTemplateState: state.taskTemplateState
});

interface IProps {
    taskTemplateState: ITaskTemplateState;
    getTaskTemplatesByFilterAsync: (filter: TemplateFilter) => Action;
}

interface IState {
    taskTemplateState: ITaskTemplateState;
    query: string;
}

export class TaskTemplateSearch extends React.Component<IProps, IState> {
    private debounceTimeoutId: number;
    private DEBOUNCE_TIMEOUT: number = 500;

    constructor(props: IProps) {
        super(props);

        const currentFilter = props.taskTemplateState.currentFilter;
        this.state = {
            taskTemplateState: props.taskTemplateState,
            query: currentFilter && currentFilter.query ? props.taskTemplateState.currentFilter.query : ""
        };

        this.clearQuery = this.clearQuery.bind(this);
        this.findTaskTemplates = this.findTaskTemplates.bind(this);
        this.filterNewQuery = this.filterNewQuery.bind(this);
    }

    public clearQuery() {
        this.filterNewQuery("");
    }

    public findTaskTemplates(event: React.FormEvent<HTMLInputElement>) {
        const newQuery = event.currentTarget.value;
        this.filterNewQuery(newQuery);
    }

    private filterNewQuery(newQuery: string) {
        if (this.debounceTimeoutId) {
            window.clearTimeout(this.debounceTimeoutId);
        }
        this.setState({ query: newQuery });

        const debounceFunction = () => {
            const filter = {
                ...this.state.taskTemplateState.currentFilter,
                query: newQuery,
                skip: 0
            };
            this.props.getTaskTemplatesByFilterAsync(filter);
        };

        this.debounceTimeoutId = window.setTimeout(debounceFunction.bind(this), this.DEBOUNCE_TIMEOUT);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState | null> {
        if (nextProps.taskTemplateState !== prevState.taskTemplateState) {
            return { taskTemplateState: nextProps.taskTemplateState };
        }
        return null;
    }

    public render() {
        return (
            <div className={styles.searchWrapper}>
                <div className={styles.icon}>
                    <Icon>search</Icon>
                </div>
                <input id="txtTaskTemplaeSearchbox" className={styles.search} type="text" placeholder={i18n.t("tasks.search.placeholder")} value={this.state.query} onChange={this.findTaskTemplates} />
                {this.state.query !== "" ? <div className={styles.clear} onClick={this.clearQuery}>X</div> : null}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskTemplateSearch);


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateSearch/TaskTemplateSearch.tsx